/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.14.7.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { getAuth0Token, getVectorBaseUrl, transformApiResult, transformRequestOptions } from './VectorClientHelpers';
export class VectorClientBase { 

    protected transformOptions(options: any) {
        return this.getToken().then(newToken => transformRequestOptions(newToken, options));
      }
  
  protected transformResult(url: string, response: Response, processor: (response: Response) => any) {
    return transformApiResult(url, response, processor);
  }

  protected getBaseUrl(urlTemplate: string, defaultUrl: string | undefined): string {
    return getVectorBaseUrl(urlTemplate, defaultUrl);
  }

  private async getToken() {
    return getAuth0Token();
  }
}

export interface IProjectsClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    projectsPOST(vaultId: number, body?: ProjectCreationRequest | undefined): Promise<ProjectApiModel>;
    /**
     * @return Success
     */
    projectsAll(vaultId: number): Promise<ProjectApiModel[]>;
    /**
     * @return Success
     */
    projectsGET(vaultId: number, projectId: number): Promise<ProjectApiModel>;
    /**
     * @param body (optional) 
     * @return Success
     */
    projectsPUT(vaultId: number, projectId: number, body?: ProjectUpdateRequest | undefined): Promise<ProjectApiModel>;
    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    projectsDELETE(vaultId: number, projectId: number, shouldDelete?: boolean | undefined): Promise<ProjectApiModel>;
    /**
     * @return Success
     */
    repositoriesAll(vaultId: number, projectId: number): Promise<RepositoryApiModel[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    repositoriesPOST(vaultId: number, projectId: number, body?: RepositoryCreationRequest | undefined): Promise<RepositoryApiModel>;
    /**
     * @return Success
     */
    repositoriesGET(vaultId: number, projectId: number, repositoryId: number): Promise<RepositoryApiModel>;
    /**
     * @param body (optional) 
     * @return Success
     */
    repositoriesPUT(vaultId: number, projectId: number, repositoryId: number, body?: RepositoryUpdateRequest | undefined): Promise<RepositoryApiModel>;
    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    repositoriesDELETE(vaultId: number, projectId: number, repositoryId: number, shouldDelete?: boolean | undefined): Promise<void>;
}

export class ProjectsClient extends VectorClientBase implements IProjectsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    projectsPOST(vaultId: number, body?: ProjectCreationRequest | undefined): Promise<ProjectApiModel> {
        let url_ = this.baseUrl + "/api/apps/friday/{vaultId}/Projects";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProjectsPOST(_response));
        });
    }

    protected processProjectsPOST(response: Response): Promise<ProjectApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectApiModel>(<any>null);
    }

    /**
     * @return Success
     */
    projectsAll(vaultId: number): Promise<ProjectApiModel[]> {
        let url_ = this.baseUrl + "/api/apps/friday/{vaultId}/Projects";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProjectsAll(_response));
        });
    }

    protected processProjectsAll(response: Response): Promise<ProjectApiModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectApiModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    projectsGET(vaultId: number, projectId: number): Promise<ProjectApiModel> {
        let url_ = this.baseUrl + "/api/apps/friday/{vaultId}/Projects/{projectId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProjectsGET(_response));
        });
    }

    protected processProjectsGET(response: Response): Promise<ProjectApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectApiModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    projectsPUT(vaultId: number, projectId: number, body?: ProjectUpdateRequest | undefined): Promise<ProjectApiModel> {
        let url_ = this.baseUrl + "/api/apps/friday/{vaultId}/Projects/{projectId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProjectsPUT(_response));
        });
    }

    protected processProjectsPUT(response: Response): Promise<ProjectApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectApiModel>(<any>null);
    }

    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    projectsDELETE(vaultId: number, projectId: number, shouldDelete?: boolean | undefined): Promise<ProjectApiModel> {
        let url_ = this.baseUrl + "/api/apps/friday/{vaultId}/Projects/{projectId}?";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (shouldDelete === null)
            throw new Error("The parameter 'shouldDelete' cannot be null.");
        else if (shouldDelete !== undefined)
            url_ += "shouldDelete=" + encodeURIComponent("" + shouldDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProjectsDELETE(_response));
        });
    }

    protected processProjectsDELETE(response: Response): Promise<ProjectApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectApiModel>(<any>null);
    }

    /**
     * @return Success
     */
    repositoriesAll(vaultId: number, projectId: number): Promise<RepositoryApiModel[]> {
        let url_ = this.baseUrl + "/api/apps/friday/{vaultId}/projects/{projectId}/Repositories";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRepositoriesAll(_response));
        });
    }

    protected processRepositoriesAll(response: Response): Promise<RepositoryApiModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RepositoryApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RepositoryApiModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    repositoriesPOST(vaultId: number, projectId: number, body?: RepositoryCreationRequest | undefined): Promise<RepositoryApiModel> {
        let url_ = this.baseUrl + "/api/apps/friday/{vaultId}/projects/{projectId}/Repositories";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRepositoriesPOST(_response));
        });
    }

    protected processRepositoriesPOST(response: Response): Promise<RepositoryApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RepositoryApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RepositoryApiModel>(<any>null);
    }

    /**
     * @return Success
     */
    repositoriesGET(vaultId: number, projectId: number, repositoryId: number): Promise<RepositoryApiModel> {
        let url_ = this.baseUrl + "/api/apps/friday/{vaultId}/projects/{projectId}/Repositories/{repositoryId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (repositoryId === undefined || repositoryId === null)
            throw new Error("The parameter 'repositoryId' must be defined.");
        url_ = url_.replace("{repositoryId}", encodeURIComponent("" + repositoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRepositoriesGET(_response));
        });
    }

    protected processRepositoriesGET(response: Response): Promise<RepositoryApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RepositoryApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RepositoryApiModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    repositoriesPUT(vaultId: number, projectId: number, repositoryId: number, body?: RepositoryUpdateRequest | undefined): Promise<RepositoryApiModel> {
        let url_ = this.baseUrl + "/api/apps/friday/{vaultId}/projects/{projectId}/Repositories/{repositoryId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (repositoryId === undefined || repositoryId === null)
            throw new Error("The parameter 'repositoryId' must be defined.");
        url_ = url_.replace("{repositoryId}", encodeURIComponent("" + repositoryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRepositoriesPUT(_response));
        });
    }

    protected processRepositoriesPUT(response: Response): Promise<RepositoryApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RepositoryApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RepositoryApiModel>(<any>null);
    }

    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    repositoriesDELETE(vaultId: number, projectId: number, repositoryId: number, shouldDelete?: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/apps/friday/{vaultId}/projects/{projectId}/Repositories/{repositoryId}?";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (repositoryId === undefined || repositoryId === null)
            throw new Error("The parameter 'repositoryId' must be defined.");
        url_ = url_.replace("{repositoryId}", encodeURIComponent("" + repositoryId));
        if (shouldDelete === null)
            throw new Error("The parameter 'shouldDelete' cannot be null.");
        else if (shouldDelete !== undefined)
            url_ += "shouldDelete=" + encodeURIComponent("" + shouldDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRepositoriesDELETE(_response));
        });
    }

    protected processRepositoriesDELETE(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ProjectApiModel implements IProjectApiModel {
    id?: number;
    name?: string | undefined;
    urls?: { [key: string]: string; } | undefined;

    constructor(data?: IProjectApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (_data["urls"]) {
                this.urls = {} as any;
                for (let key in _data["urls"]) {
                    if (_data["urls"].hasOwnProperty(key))
                        (<any>this.urls)![key] = _data["urls"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProjectApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (this.urls) {
            data["urls"] = {};
            for (let key in this.urls) {
                if (this.urls.hasOwnProperty(key))
                    (<any>data["urls"])[key] = this.urls[key];
            }
        }
        return data; 
    }
}

export interface IProjectApiModel {
    id?: number;
    name?: string | undefined;
    urls?: { [key: string]: string; } | undefined;
}

export class ProjectCreationRequest implements IProjectCreationRequest {
    projectName!: string;
    urls!: { [key: string]: string; };
    tags!: string[];

    constructor(data?: IProjectCreationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.urls = {};
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectName = _data["projectName"];
            if (_data["urls"]) {
                this.urls = {} as any;
                for (let key in _data["urls"]) {
                    if (_data["urls"].hasOwnProperty(key))
                        (<any>this.urls)![key] = _data["urls"][key];
                }
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): ProjectCreationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCreationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        if (this.urls) {
            data["urls"] = {};
            for (let key in this.urls) {
                if (this.urls.hasOwnProperty(key))
                    (<any>data["urls"])[key] = this.urls[key];
            }
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data; 
    }
}

export interface IProjectCreationRequest {
    projectName: string;
    urls: { [key: string]: string; };
    tags: string[];
}

export class ProjectUpdateRequest implements IProjectUpdateRequest {
    newParentId!: number;
    projectName!: string;
    urls!: { [key: string]: string; };
    tags!: string[];

    constructor(data?: IProjectUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.urls = {};
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newParentId = _data["newParentId"];
            this.projectName = _data["projectName"];
            if (_data["urls"]) {
                this.urls = {} as any;
                for (let key in _data["urls"]) {
                    if (_data["urls"].hasOwnProperty(key))
                        (<any>this.urls)![key] = _data["urls"][key];
                }
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): ProjectUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newParentId"] = this.newParentId;
        data["projectName"] = this.projectName;
        if (this.urls) {
            data["urls"] = {};
            for (let key in this.urls) {
                if (this.urls.hasOwnProperty(key))
                    (<any>data["urls"])[key] = this.urls[key];
            }
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data; 
    }
}

export interface IProjectUpdateRequest {
    newParentId: number;
    projectName: string;
    urls: { [key: string]: string; };
    tags: string[];
}

export class RepositoryApiModel implements IRepositoryApiModel {
    id?: number;
    name?: string | undefined;
    webpageUrl?: string | undefined;
    gitUrl?: string | undefined;
    sshUrl?: string | undefined;
    deployedInstances?: { [key: string]: string; } | undefined;

    constructor(data?: IRepositoryApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.webpageUrl = _data["webpageUrl"];
            this.gitUrl = _data["gitUrl"];
            this.sshUrl = _data["sshUrl"];
            if (_data["deployedInstances"]) {
                this.deployedInstances = {} as any;
                for (let key in _data["deployedInstances"]) {
                    if (_data["deployedInstances"].hasOwnProperty(key))
                        (<any>this.deployedInstances)![key] = _data["deployedInstances"][key];
                }
            }
        }
    }

    static fromJS(data: any): RepositoryApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new RepositoryApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["webpageUrl"] = this.webpageUrl;
        data["gitUrl"] = this.gitUrl;
        data["sshUrl"] = this.sshUrl;
        if (this.deployedInstances) {
            data["deployedInstances"] = {};
            for (let key in this.deployedInstances) {
                if (this.deployedInstances.hasOwnProperty(key))
                    (<any>data["deployedInstances"])[key] = this.deployedInstances[key];
            }
        }
        return data; 
    }
}

export interface IRepositoryApiModel {
    id?: number;
    name?: string | undefined;
    webpageUrl?: string | undefined;
    gitUrl?: string | undefined;
    sshUrl?: string | undefined;
    deployedInstances?: { [key: string]: string; } | undefined;
}

export class RepositoryCreationRequest implements IRepositoryCreationRequest {
    name!: string;
    webpageUrl!: string;
    gitUrl?: string | undefined;
    sshUrl?: string | undefined;
    deployedInstances?: { [key: string]: string; } | undefined;

    constructor(data?: IRepositoryCreationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.webpageUrl = _data["webpageUrl"];
            this.gitUrl = _data["gitUrl"];
            this.sshUrl = _data["sshUrl"];
            if (_data["deployedInstances"]) {
                this.deployedInstances = {} as any;
                for (let key in _data["deployedInstances"]) {
                    if (_data["deployedInstances"].hasOwnProperty(key))
                        (<any>this.deployedInstances)![key] = _data["deployedInstances"][key];
                }
            }
        }
    }

    static fromJS(data: any): RepositoryCreationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RepositoryCreationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["webpageUrl"] = this.webpageUrl;
        data["gitUrl"] = this.gitUrl;
        data["sshUrl"] = this.sshUrl;
        if (this.deployedInstances) {
            data["deployedInstances"] = {};
            for (let key in this.deployedInstances) {
                if (this.deployedInstances.hasOwnProperty(key))
                    (<any>data["deployedInstances"])[key] = this.deployedInstances[key];
            }
        }
        return data; 
    }
}

export interface IRepositoryCreationRequest {
    name: string;
    webpageUrl: string;
    gitUrl?: string | undefined;
    sshUrl?: string | undefined;
    deployedInstances?: { [key: string]: string; } | undefined;
}

export class RepositoryUpdateRequest implements IRepositoryUpdateRequest {
    newParentId!: number;
    name!: string;
    webpageUrl!: string;
    gitUrl?: string | undefined;
    sshUrl?: string | undefined;
    deployedInstances?: { [key: string]: string; } | undefined;

    constructor(data?: IRepositoryUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newParentId = _data["newParentId"];
            this.name = _data["name"];
            this.webpageUrl = _data["webpageUrl"];
            this.gitUrl = _data["gitUrl"];
            this.sshUrl = _data["sshUrl"];
            if (_data["deployedInstances"]) {
                this.deployedInstances = {} as any;
                for (let key in _data["deployedInstances"]) {
                    if (_data["deployedInstances"].hasOwnProperty(key))
                        (<any>this.deployedInstances)![key] = _data["deployedInstances"][key];
                }
            }
        }
    }

    static fromJS(data: any): RepositoryUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RepositoryUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newParentId"] = this.newParentId;
        data["name"] = this.name;
        data["webpageUrl"] = this.webpageUrl;
        data["gitUrl"] = this.gitUrl;
        data["sshUrl"] = this.sshUrl;
        if (this.deployedInstances) {
            data["deployedInstances"] = {};
            for (let key in this.deployedInstances) {
                if (this.deployedInstances.hasOwnProperty(key))
                    (<any>data["deployedInstances"])[key] = this.deployedInstances[key];
            }
        }
        return data; 
    }
}

export interface IRepositoryUpdateRequest {
    newParentId: number;
    name: string;
    webpageUrl: string;
    gitUrl?: string | undefined;
    sshUrl?: string | undefined;
    deployedInstances?: { [key: string]: string; } | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}